import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { FormModule } from 'shared/form/form.module';
import { SharedModule } from 'shared/shared.module';

import { ResetPasswordComponent } from './reset-password.component';
import { ResetPasswordRoutingModule } from './reset-password-routing.module';
import { ResetPasswordService } from './reset-password.service';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ResetPasswordRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    FormModule,
  ],
  providers: [ResetPasswordService],
  declarations: [ResetPasswordComponent],
  exports: [ResetPasswordComponent]
})
export class ResetPasswordModule {}
